import styled from "styled-components";

export const CardWrapper = styled.section`
  flex: 1;
  box-sizing: content-box;

  margin-bottom: 16px;

  padding: 16px;
`;